var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pipeline-step",
      class: _vm.classes,
      on: {
        click: function() {
          return !_vm.isPaginated ? _vm.handleUpdate() : null
        }
      }
    },
    [
      !_vm.isPaginated
        ? _c(
            "CompassTooltip",
            {
              attrs: { arrow: false, contentClass: "pipeline-step__tooltip" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.tooltipContent) }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1971197019
              )
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pipeline-step__wrapper" },
                [
                  !_vm.finished
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "pipeline-step__label typographies-paragraph-small-regular"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.step.name) +
                              "\n            "
                          )
                        ]
                      )
                    : _c("CompassIcon", {
                        attrs: { icon: "check", size: "small" }
                      })
                ],
                1
              )
            ]
          )
        : _c(
            "div",
            { staticClass: "pipeline-step__wrapper" },
            [
              _c(
                "CompassMenu",
                {
                  attrs: {
                    trigger: "hover",
                    size: "small",
                    placement: "bottom"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "dropdown",
                      fn: function() {
                        return _vm._l(_vm.step, function(subStep) {
                          return _c("CompassMenuItem", {
                            key: subStep.id,
                            attrs: { label: subStep.name },
                            on: {
                              click: function($event) {
                                return _vm.handleUpdate(subStep)
                              }
                            }
                          })
                        })
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "ellipsis", size: "extra-small" }
                  })
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }